export const ANIMATION_DURATION_MS = 160;
